import React, { useEffect, useRef, useState } from 'react';
import { menuImportReviewIssues } from '../../services/local/menuImportDraft';

export function MenuImportRow({ row, index, disabled, duplicate, onUpdate }) {
  return <fieldset>
    <legend>Plato {index + 1}</legend>
    <label className="menu-import__check"><input type="checkbox" checked={row.selected} disabled={disabled}
      onChange={(event) => onUpdate(row.rowId, { selected: event.target.checked })} /> Importar este plato</label>
    {duplicate(row) && <p className="menu-import__warning">Ya existe con este nombre y grupo. No se modificara.</p>}
    <div className="menu-import__fields">
      {[
        ['name', 'Nombre', 150], ['category', 'Categoria', 100], ['subcategory', 'Subcategoria (opcional)', 100], ['price', 'Precio en pesos', 12],
      ].map(([key, label, max]) => <label key={key}>{label}<input aria-label={`${label} ${index + 1}`} value={row[key]} maxLength={max}
        inputMode={key === 'price' ? 'decimal' : undefined} disabled={disabled || !row.selected}
        onChange={(event) => onUpdate(row.rowId, { [key]: event.target.value })} /></label>)}
      <label className="menu-import__description">Descripcion<textarea aria-label={`Descripcion ${index + 1}`} value={row.description}
        maxLength={1500} disabled={disabled || !row.selected} onChange={(event) => onUpdate(row.rowId, { description: event.target.value })} /></label>
    </div>
    {row.priceText && <p>Precio leido en el archivo: <strong>{row.priceText}</strong></p>}
    {row.note && <p className="menu-import__warning">{row.note}</p>}
  </fieldset>;
}

export default function MenuImportReview({ rows, index, reviewedIds, disabled, duplicate, onUpdate, onIndexChange, onReview }) {
  const [error, setError] = useState('');
  const title = useRef(null);
  const summary = index >= rows.length;
  const reviewed = rows.filter((row) => reviewedIds.includes(row.rowId)).length;
  const issues = menuImportReviewIssues(rows);
  const pendingIndex = rows.findIndex((row) => !reviewedIds.includes(row.rowId));
  useEffect(() => {
    setError('');
    title.current?.focus({ preventScroll: true });
    title.current?.scrollIntoView?.({ block: 'start' });
  }, [index]);
  const next = () => {
    const issue = menuImportReviewIssues([rows[index]])[0];
    if (issue) { setError(issue.message); return; }
    setError(''); onReview(rows[index].rowId); onIndexChange(index + 1);
  };
  return <section className="menu-import__guided" aria-label="Revision guiada de la carta">
    <div className="menu-import__review-heading">
      <h4 ref={title} tabIndex={-1}>{summary ? 'Resumen antes de crear platos' : `Revisar plato ${index + 1} de ${rows.length}`}</h4>
      <span role="status">{reviewed} de {rows.length} revisados</span>
    </div>
    <progress aria-label="Platos revisados" value={reviewed} max={rows.length} />
    {summary ? <>
      <p><strong>{rows.filter((row) => row.selected).length} seleccionados</strong>. {rows.filter((row) => !row.selected).length} quedan fuera de esta importacion.</p>
      <p>Confirmar creara platos ocultos y no disponibles. Los duplicados existentes se omiten, sin reemplazarlos.</p>
      {pendingIndex >= 0 && <p className="menu-import__warning">Todavia hay platos sin revisar.</p>}
      {issues.length > 0 && <div role="alert"><p>Falta corregir antes de guardar:</p><ul>{issues.map((issue) => <li key={issue.rowId}>
        Plato {issue.index + 1}: {issue.message} <button type="button" disabled={disabled} onClick={() => onIndexChange(issue.index)}>Corregir plato {issue.index + 1}</button>
      </li>)}</ul></div>}
      <ul className="menu-import__review-summary">{rows.map((row, position) => <li key={row.rowId}>
        <div><strong>{row.name || `Plato ${position + 1}`}</strong><span>{row.selected ? `Seleccionado | ${row.price === '' ? 'Precio pendiente' : `$ ${row.price}`}` : 'No importar'}{reviewedIds.includes(row.rowId) ? '' : ' | Sin revisar'}</span></div>
        <button type="button" disabled={disabled} onClick={() => onIndexChange(position)}>Revisar plato {position + 1}</button>
      </li>)}</ul>
      {pendingIndex >= 0 && <button type="button" disabled={disabled} onClick={() => onIndexChange(pendingIndex)}>Continuar con el primer pendiente</button>}
    </> : <>
      <p>Compara este plato con tu carta. Podes corregirlo o desmarcarlo para no importarlo.</p>
      <MenuImportRow row={rows[index]} index={index} disabled={disabled} duplicate={duplicate} onUpdate={(...args) => { setError(''); onUpdate(...args); }} />
      {error && <p role="alert" className="menu-import__error">{error}</p>}
      <div className="menu-import__review-actions">
        <button type="button" disabled={disabled || index === 0} onClick={() => onIndexChange(index - 1)}>Plato anterior</button>
        <button type="button" className="menu-import__confirm" disabled={disabled} onClick={next}>{rows[index].selected ? 'Revisado, continuar' : 'Continuar sin este plato'}</button>
        <button type="button" disabled={disabled} onClick={() => onIndexChange(rows.length)}>Ver resumen</button>
      </div>
    </>}
  </section>;
}
